module.exports = __webpack_public_path__ + "static/media/1.da568c57.JPG";